import React from 'react';
import PropTypes from 'prop-types';

const MaterialInput = ({className, name, value, onChange, label, inputRef, ...rest}) => { 
    return (
        <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block ${className || ''}`}>
            <input name={name} className="mdl-textfield__input" value={value} onChange={onChange} ref={inputRef} {...rest} />
            <label className="mdl-textfield__label" htmlFor={name}>{label || name}</label>
        </div>
    );
};

MaterialInput.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    label: PropTypes.string,
    inputRef: PropTypes.func
};

export default MaterialInput;
